export default {"src":"/_next/static/media/minus-outline-1.b2277e81.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};